import React from 'react';
import ATable from '../../common/table';

const ReasonCodesTable = (props) => {
    
 
    const columns = [{
        header: "S/N",
        width: 50,
        render: row => (<div>{props.paginatedCallback(row.viewIndex)}</div>)
    }, 
    {
        header: "Name",
        accessor: "name",
        width :250
    },
    {
        header: "Code",
        accessor: "code",
        width :100
    },
    {
        header: "Category",
        accessor: "disputeCategory",
        width :150
    },
    {
        header: "Description",
        accessor: "description"
    }
    ];
    return (
            <ATable
                className="-striped -highlight"
                    tableData={props.reasonCodes}
                    columns={columns}
                    onChange={props.onTableChange || null}
                    
                    manual
                    {...props} />
    )
};

export default ReasonCodesTable;


// WEBPACK FOOTER //
// ./src/components/admin/reasonCodes/reasonCodesTable.js